import { targetable } from '@github/catalyst/lib/targetable'
import { actionable } from '@github/catalyst/lib/actionable'

export default actionable(targetable(class extends HTMLElement {
  toggle (event) {
    const value = event.target.value
    // Toggle visibility of storage forms
    const elementIds = ['disk', 'aws_s3', 'google', 'azure']
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId)
      if (element) {
        element.classList.toggle('hidden', value !== elementId)
      }
    })
    // Toggle button disabled state
    const button = this.querySelector('button[type="submit"]') || this.querySelector('button[type="button"]')
    if (button) {
      button.disabled = !value || value === ''
    }
  }
}))
